require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./information-security-and-quality-assurance-quality-assurance-and-testing-with-chai-test-if-a-string-contains-a-substring.json") })
        }
      }, "path---information-security-and-quality-assurance-quality-assurance-and-testing-with-chai-test-if-a-string-contains-a-substring");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---information-security-and-quality-assurance-quality-assurance-and-testing-with-chai-test-if-a-string-contains-a-substring!./.cache/json/information-security-and-quality-assurance-quality-assurance-and-testing-with-chai-test-if-a-string-contains-a-substring.json
// module id = 2196
// module chunks = 231608221292675